import type { Pagination } from "@/types";

import { BaseApi } from "../base.api";

export type GradeChangeKind = "JOURNAL" | "ASSIGNMENT" | "QUIZ";

/** Baho o'zgarishi (eski → yangi) — backend'dagi `GradeChangeDto`. */
export interface GradeChange {
  id: number;
  kind: GradeChangeKind;
  courseId: number;
  courseTitle: string;
  refId: number;
  title: string;
  student: { id: number; firstName: string; lastName: string };
  actor: { id: number; firstName: string; lastName: string } | null;
  oldScore: number | null;
  newScore: number | null;
  maxScore: number;
  /** "HOMEWORK" (uy vazifasidan tortildi), "RETURNED", "ESSAY" yoki `null`. */
  source: string | null;
  createdAt: string;
}

export interface GradeChangeQuery {
  courseId?: number;
  studentId?: number;
  kind?: GradeChangeKind;
  actorId?: number;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

/** Baho o'zgarishlari tarixi — admin va moderator hamma kurslarni ko'radi. */
export class GradeChangesApi extends BaseApi {
  private readonly baseUrl: string = "/grade-changes";

  list(query: GradeChangeQuery = {}) {
    return this.request.get<GradeChange[], Pagination<GradeChange>>(this.baseUrl, {
      params: query,
    });
  }
}

export const gradeChangesApi = new GradeChangesApi();
